import React from 'react';
import { Link } from 'react-router-dom';
import { siteLinks } from './Header';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <nav className="footer-links" aria-label="Acceso rápido">
          <h2>Acceso Rápido</h2>
          <a href={siteLinks.services}>Servicios</a>
          <a href={siteLinks.quote}>Cotizar</a>
          <Link to="/">Pagar Cotización</Link>
          <a href={siteLinks.tracking}>Consultar Trámite</a>
          <a href={siteLinks.faq}>Preguntas Frecuentes</a>
        </nav>
        <a className="footer-logo" href={siteLinks.home} aria-label="Tus Multas, sitio principal">
          <img src={`${process.env.PUBLIC_URL}/design/tusmultas-footer-logo.png`} alt="tusmultas.cl" width="512" height="512" />
        </a>
        <div className="footer-contact">
          <h2>Contáctanos</h2>
          <address>
            <a href="https://maps.app.goo.gl/hSGnqwsM15qSpMb7A" target="_blank" rel="noopener noreferrer">
              Estado 235, Ofic. 701 - Santiago.
            </a>
          </address>
          <a href="https://wa.me/56973143517" target="_blank" rel="noopener noreferrer">+56 9 7314 3517</a>
          <a href="mailto:libera@tusmultas.cl">libera@tusmultas.cl</a>
          <p>Lunes a Jueves: 9:00 a 18:00 hrs.<br />Viernes: 9:00 a 17:00 hrs.</p>
        </div>
      </div>
    </footer>
  );
}